import { render } from "./question-5.vue?vue&type=template&id=337a7566&ts=true"
import script from "./question-5.vue?vue&type=script&lang=ts"
export * from "./question-5.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__